import { StripePriceMetaDataI } from '@/Types/stripeTypes'

export enum SubscriptionPlan {
    Basic = 'basic',
    Full = 'full',
}

interface Recurring {
    licensed: {
        month: number
    }
    usage: {
        type: 'metered'
        metadata: StripePriceMetaDataI
        tiers: {
            up_to: number | 'inf'
            unit_amount: number
        }[]
    }
}

export const SubscriptionMeters: Record<SubscriptionPlan, Recurring> = {
    [SubscriptionPlan.Basic]: {
        licensed: {
            month: 0, // perhaps Basic is free or has different licensed rate
        },
        usage: {
            type: 'metered',
            metadata: {
                price_per_unit: 0,
                one_unit_is_equal_to: 262144000, // 250 MB
            },
            tiers: [],
        },
    },
    [SubscriptionPlan.Full]: {
        licensed: {
            month: 2999, // $29.99/month
        },
        usage: {
            type: 'metered',
            metadata: {
                price_per_unit: 1000, // $10 per 100GB
                one_unit_is_equal_to: 107374182400, // 1 unit = 100GB in bytes
            },
            tiers: [
                { up_to: 1, unit_amount: 0 }, // First 100GB free
                { up_to: 'inf', unit_amount: 1000 }, // $10 per 100GB beyond
            ],
        },
    },
}
